export default "__VITE_ASSET__wd0Fuqm4__"